<script setup lang="ts">
import type { Color } from '@ui/types/base/color'

import { toRefs } from 'vue'

const props = withDefaults(
  defineProps<{
    active: boolean
    selected: boolean
    selectedColor?: Color
  }>(),
  {
    active: false,
    selected: false,
    selectedColor: undefined
  }
)

const { active, selected, selectedColor } = toRefs(props)
</script>

<template>
  <li
    :class="[
      'relative cursor-pointer select-none px-2 py-1.5 rounded-md',
      {
        [useBackgroundColor(selectedColor)]: selected && selectedColor,
        'bg-secondary/20': selected && !selectedColor,
        'font-bold': selected,
        'bg-gray-100': active && !selected
      }
    ]"
  >
    <span class="block truncate">
      <slot />
    </span>
  </li>
</template>
